import { Badge } from "@capacit-com/lara-law-shared-ui";
import { LegislationStatus } from "@/models/legislation/Legislation";

const StatusBadge = ({
  status,
  className,
}: {
  status: LegislationStatus;
  className?: string;
}) => {
  return (
    <Badge
      variant={status === LegislationStatus.Historic ? "gray" : "success"}
      className={className}
    >
      {status === LegislationStatus.Historic ? "Ikke-gældende" : "Gældende"}
    </Badge>
  );
};

export default StatusBadge;
